// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__f52Yt","unreadBadge":"styles_unreadBadge__2bbry","modalContent":"styles_modalContent__jKxoD","modal":"styles_modal__JyX3s"};